import InfoIcon from '@mui/icons-material/Info';
import { Link, Stack, Theme, Typography } from '@mui/material';
import { FlexPaper } from '@verifime/components';
import tokens from '@verifime/design-tokens';
import { DocumentType, TIdentityDocumentType } from '@verifime/utils';
import { DOCUMENT_INSTRUCTIONS } from './constant';

export default function ExtraInfo({
  documentType,
  dataTestId,
}: Readonly<{ documentType: TIdentityDocumentType; dataTestId?: string }>) {
  if (!(documentType in DOCUMENT_INSTRUCTIONS)) {
    return null;
  }

  if (documentType === DocumentType.DriverLicence) {
    return (
      <FlexPaper
        sx={{
          flexDirection: 'row',
          borderRadius: tokens.borderRadiusSm,
          padding: `${tokens.spacing2xs} ${tokens.spacingXs}`,
        }}
        data-testid={dataTestId}
        data-component="DocumentTypeSelection-ExtraInfo"
      >
        {/* TODO: Change to same tokens once we have a proper design token for this */}
        <InfoIcon
          sx={{
            color: (theme: Theme) => {
              return theme.palette.mode === 'dark'
                ? theme.palette.primary.dark
                : theme.palette.primary.light;
            },
          }}
        />
        <Stack direction="row" gap={tokens.spacing2xs} justifyContent="center" alignItems="center">
          {/* TODO: Change to tokens once we have a design token for this */}
          <Typography variant="body1" sx={{ lineHeight: '150%', letterSpacing: '0.15px' }}>
            Find out where each field is on driver’s licenses
          </Typography>
          <Link
            href="https://greengatefintech.atlassian.net/wiki/external/ZDRiMmU3YjNjMDNiNDE3MzhlMDhiZjUyZTgzNDczZTk"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </Link>
        </Stack>
      </FlexPaper>
    );
  }
  return null;
}
